// extracted by css-extract-rspack-plugin
export default {"cls1":"TabbedPreviewList-cls1_4K8","cls2":"TabbedPreviewList-cls2_n6c TabbedPreviewList-cls1_4K8"};